import React from 'react';
import { css } from 'styled-components';
import Media from 'react-media';
import LogoGroup from './components/LogoGroup';
import FooterNav from './components/FooterNav';
import MediaBorders from 'constants/media-borders';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';

const PCFooter = ({ className }) => (
  <footer className={className}>
    <FooterNav />
    <LogoGroup />
  </footer>
);

const SPFooter = ({ className }) => (
  <footer className={className}>
    <FooterNav />
    <LogoGroup />
  </footer>
);

const commonStyle = css`
  width: 100%;
  background-color: ${Colors.gray4};
`;

const pcStyle = css`
  height: 248px;
  padding: 68px 0 0;

  ${FooterNav} {
    margin-bottom: 52px;
  }
`;

const spStyle = css`
  min-height: 257px;
  padding: 28px 0 0;
`;

const StyledPCFooter = applyStyles(PCFooter)(commonStyle, pcStyle);

const StyledSPFooter = applyStyles(SPFooter)(commonStyle, spStyle);

export default () => (
  <Media
    query={`(min-width: ${MediaBorders.umedium})`}
    children={matches => (matches ? <StyledPCFooter /> : <StyledSPFooter />)}
  />
);



// WEBPACK FOOTER //
// ./src/components/common/Footer/index.js